import Vue from 'vue'
import { formatDistance, format, parseJSON } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'

Vue.filter('localDate', function (value, formatString = 'MM/dd/yyyy') {
	if (!value) return ''
	const jsonDate = parseJSON(value)
	return format(jsonDate, formatString)
})

Vue.filter('humanDate', function (value) {
	if (!value) return ''
	const newDate = new Date(value)
	return newDate.toLocaleString('en-US', {
		month: 'short', // "Jun"
		day: '2-digit', // "01"
		year: 'numeric' // "2019"
	})
})

Vue.filter('localDateTime', function (value, formatString = 'MM/dd/yyyy @ hh:mm a') {
	if (!value) return ''
	const jsonDate = parseJSON(value)
	return format(jsonDate, formatString)
})

Vue.filter('dateTime', function (value, formatString = 'MM/dd/yyyy @ hh:mm a') {
	if (!value) return ''
	const jsonDate = parseJSON(value)
	const zonedDate = utcToZonedTime(jsonDate, 'Etc/UTC')
	return format(zonedDate, formatString)
})

Vue.filter('plainDateTime', function (value) {
	if (!value) return ''
	const newDate = new Date(value)
	const hasTime = newDate.getUTCHours() !== 0 || newDate.getUTCMinutes() !== 0

	return newDate.toLocaleString('en-US', {
		timeZone: 'UTC',
		month: 'short',
		day: '2-digit',
		year: 'numeric',
		...(hasTime && {
			hour: '2-digit',
			minute: '2-digit'
		})
	})
})

Vue.filter('plainDate', function (value) {
	if (!value) return ''
	const newDate = new Date(value)
	return newDate.toLocaleString('en-US', {
		timeZone: 'UTC',
		month: 'short',
		day: '2-digit',
		year: 'numeric'
	})
})

Vue.filter('timeSince', function (value, showAgo = true) {
	if (!value) return ''
	const jsonDate = parseJSON(value)
	return formatDistance(jsonDate, new Date()) + ( showAgo ? ' ago' : '')
})

Vue.filter('prettyBytes', function (num) {
	// jacked from: https://github.com/sindresorhus/pretty-bytes
	num = parseInt(num, 10)

	if (typeof num !== 'number' || isNaN(num)) {
		throw new TypeError('prettyBytes expected a number, could not convert')
	}

	let exponent
	let unit
	let neg = num < 0
	let units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

	if (neg) num = -num
	if (num < 1) return (neg ? '-' : '') + num + ' B'

	exponent = Math.min(Math.floor(Math.log(num) / Math.log(1000)), units.length - 1)
	num = (num / Math.pow(1000, exponent)).toFixed(2) * 1
	unit = units[exponent]

	return (neg ? '-' : '') + num + ' ' + unit
})

Vue.filter('money', function (num) {
	if (!num) {
		num = 0
	}

	try {
		num = Number(num)

		return num.toLocaleString('en-US', {
			style: 'currency',
			currency: 'USD'
		})
	} catch (e) {
		return 'err'
	}
})

Vue.filter('label', function (str) {
	str = str.replaceAll('_', ' ')
	return str
})

Vue.filter('numeric', function (str) {
	str = str.replace(/[^0-9,.]/g, '')
	return str
})

Vue.filter('integer', function (str) {
	str = str.replace(/\D/g, '')
	return str
})

Vue.filter('formatNumber', function(value) {
	if (value === null || value === undefined || value === '') {
		return '';
	}

	value = value.toString().replace(/[^0-9.-]/g, '');

	let number = parseFloat(value);
	if (isNaN(number)) {
		return value;
	}

	return number.toLocaleString();
});

